/**
 * Environment and configuration utilities
 *
 */

export const isProdEnvironment = () =>
  typeof window !== 'undefined' &&
  window.location.hostname === 'www.homedepot.com';

export const getGlobalRequestTimeout = () =>
  isProdEnvironment() ? 20000 : 60000;
